export default {"src":"/_next/static/media/phone.453cc6fe.svg","height":35,"width":35};